<template>
  <div id="user-management">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Organisasi</li>
      <li class="active">Daftar Organisasi</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Organizations Management</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Organisasi
            </div>
            <div>
              <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="$router.push('/organizations/form')">Buat Organisasi</button>
            </div>
          </div>
          <div class="panel-body">
            <div class="searchbox" style="width:100%;">
              <input type="text" class="form-control" v-model="query" @keyup.enter="loadOrganizationsData(1)" placeholder="Masukkan kata kunci dan tekan enter">
            </div>

            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Organisasi</th>
                  <th>Jumlah Cabang</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(organization, key) in organizations" v-bind:key="key" @dblclick="goToDetail(organization.id)">
                  <td>{{ (25 * (pageNumber - 1)) + (key + 1) }}</td>
                  <td>{{ organization.name }}</td>
                  <td>{{ organization.child_count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer">
            <div class="btn-group">
              <button class="btn btn-white" :disabled="pageNumber === 1" type="button" @click="loadOrganizationsData(--pageNumber)">
                Previous
              </button>
              <input type="text" class="form-control" :value="pageNumber + ' / ' + total_page" style="width: 50px; text-align: center">
              <button class="btn btn-white" :disabled="isDisabledNextBtn" type="button" @click="loadOrganizationsData(++pageNumber)">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import axios from 'axios'
import AppSpinner from '@/components/plugins/Spinner'
import DataTable from '@/components/plugins/DataTable'

export default {
  name: 'user-management',
  components: {
    'app-spinner': AppSpinner,
    'app-datatable': DataTable
  },
  data: function () {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      organizations: [],
      total_page: 0,
      isDisabledNextBtn: false
    }
  },
  watch: {
    pageNumber: function(newVal) {
      this.loadOrganizationsData(newVal)
    }
  },
  methods: {
    loadOrganizationsData: function (pageNumber = 1) {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/v2/organizations'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {
        params: {
          page: pageNumber,
          name: this.query
        }
      })
      .then(function(response) {
        if (response.data.length < 25) {
          context.isDisabledNextBtn = true
        } else {
          context.isDisabledNextBtn = false
        }
        context.organizations = response.data.data
        context.total_page = response.data.total_page
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        context.isLoading = false
      })
    },
    goToDetail: function(id) {
      this.$router.push('organization/' + id)
    }
  },
  mounted: function () {
    this.loadOrganizationsData()
  }
}
</script>




// WEBPACK FOOTER //
// Organizations.vue?12be813d